import { UpdateStripePendingInput } from "@/domain/dtos/inputs";
import { z } from "zod";
import { CameraFileSchema } from "./CameraFileSchema";

export const UpdateStripePendingInputSchema: z.ZodType<UpdateStripePendingInput> =
  z.object({
    // UpdateBankInput fields
    bank: z.string().optional(),
    bank_code: z.string(),
    agencia: z.string(),
    agencia_dv: z.string().nullable(),
    conta: z.string(),
    conta_dv: z.string().nullable(),
    document_number: z.string().optional(),
    // CreateAddressInput fields
    address_postal_code: z.string(),
    address_state: z.string(),
    address_city: z.string(),
    address_line1: z.string(),
    address_line2: z.string(),
    // UpdateStripePendingInput own fields
    business_type: z.string(),
    bank_document_back: CameraFileSchema,
    bank_document_front: CameraFileSchema,
    user_id: z.number(),
  });
